import React, { FunctionComponent } from 'react';
import styles from './Surface.less';

export const Surface: FunctionComponent = ({ children }) => {
  return (
    <div id="surface" className={styles.surface}>
      {children}
    </div>
  );
};
